export const EmailTemplate = {
  fourthOfJuly:'4th Of July',
  productColumns: {
    btn_col: 'u_row_14111111111111111111111111',
    product_col_second: 'u_row_14111111111111111111111111111111111111111',
    product_col_first: 'u_row_1411111111111111111111111111111111111111',
  },
  announcementColumn: {
    announcement_col_first: 'u_row_14111111111111111111111',
  },
  logoId: 'u_content_image_31',
  companyName: 'u_content_heading_2',
  companyLocation: 'u_content_heading_8',
  companyLocation_product: 'u_content_text_11111111',
  companyAddress: 'u_content_heading_6',
  companyPhone: 'u_content_button_41111111',
  companyFooter: 'u_content_text_111111111111111111111111111111111111111111111111',
  companyLink: 'u_content_button_411111',
  productPhone: 'u_content_button_411111111111',
  productcompanyLink: 'u_content_button_411111111111111',
  buttonRow: 'u_row_14111111111111111111111',
  u_content_button: 'u_content_button',
  u_content_heading: 'u_content_heading',
  u_content_custom_Product: 'u_content_custom_Product',
  customFooterTemplate: `<p style="font-size: 14px; line-height: 200%; text-align: center;"><a href="[company_location]" target = "_blank" style = "text-decoration: underline;color:[company_color]" > [company_address_1]</a><br/><a href="tel:[company_phone]" target = "_blank" style = "text-decoration: underline;color:[company_color]" > [company_phone]</a><br/><span style="text-decoration: underline; font-size: 14px; line-height: 28px;"><a class="unsubscribe_email_link" style="color:[company_color]" href="[unsubscribe_email_link]">Unsubscribe</a></span> from our emails.<br /><strong>Powered by © AutoLeap Inc., ${new Date().getFullYear()}. All rights reserved.</strong></p>`,
  footerTemplate: `<p style="font-size: 14px; line-height: 200%; text-align: center;"><span style="text-decoration: underline; font-size: 14px; line-height: 28px;"><a class="unsubscribe_email_link" style="color:[company_color]" href="[unsubscribe_email_link]">Unsubscribe</a></span> from our emails. This is a preview email, the unsubscribe link will be interactive and customer will be able to unsubscribe in the actual email.<br /><strong>Powered by © AutoLeap Inc., ${new Date().getFullYear()}. All rights reserved.</strong></p>`,
  footerReverseTemplate: '<p style="font-size: 14px; line-height: 200%; text-align: center;">[template_html_footer]</p>',
  productCustomCss: `.blockbuilder-preview{background-image:none;overflow: auto;}
  .u_content_heading div{padding:0px !important;margin: -7px 0px 3px 4px;}
.blockbuilder-content-tool.disabled,
.blockbuilder-classic-tools,
.tox-toolbar__group:nth-child(4),

.dsTOvD:nth-child(3),
.dsTOvD:nth-child(4),.dsTOvD:nth-child(5),
.blockbuilder-duplicate,
.icon-duplicate,
.blockbuilder-row-tools div:nth-child(3),.blockbuilder-row-tools div:nth-child(4),.blockbuilder-row-tools div:nth-child(5),
.blockbuilder-row-tools div:nth-child(6),.blockbuilder-row-tools div:nth-child(7),.blockbuilder-row-tools div:nth-child(8),
.blockbuilder-layer-drag-contents,
.blockbuilder-placeholder:nth-child(3)
{display: none !important}
.blockbuilder-placeholder{display: none; }

#u_row_14111111111111111111111111 .blockbuilder-placeholder:nth-child(1){ display: block !important; }

.blockbuilder-content-tools{background:white;}

.u_content_button{padding: 25px 0px !important;}

#u_row_14111111111111111111111111111111111111111 .blockbuilder-placeholder:nth-child(1),
#u_row_1411111111111111111111111111111111111111 .blockbuilder-placeholder:nth-child(1)
{ display: block !important; }


#u_content_image_31,#u_content_image_31 img{min-height: 50px;max-height: 100px;}

.u_content_button a,.u_content_button span{border-radius: 80px !important;padding: 7px 10px !important;}
.xRWac .nav-tabs .nav-item a,
.xRWac .nav-tabs .nav-item .nav-link.active {
  color: #ffffff !important;
  background-color: #00c19d !important;
  border-color: #00c19d !important;
}
.hESrRY{right:375px !important}
.enable-row-layer-outer-space{padding-top:0px !important}
.blockbuilder-options-header .icon{border: none !important;}
.react-toggle--checked .react-toggle-track,.blockbuilder-widget-label .btn-primary,.blockbuilder-widget-label
.rc-slider-track{
  background-color:#00c19d !important;border: 1px solid #00c19d !important}
  .tool-panel-container .cancel-button {overflow: revert!important;text-overflow: revert!important;padding: 0px 0px!important;}
    .button-overlay mat-icon{color:#00c19d !important}
    .ReactModalPortal .btn-danger{background-color: #6c757d !important;border-color: #6c757d !important;}
  `,
  productCustomJss: [
    `
  setTimeout(()=>{
    document.getElementsByClassName("nav-name")[0].innerText='Interactive'
  },0);
  `,
  ],
  // .blockbuilder-text-widget,
  templateCss: `
 .u_content_heading div{padding:0px !important;margin: -7px 0px 3px 4px;}
.blockbuilder-preview{background-image:none}
.blockbuilder-content-tool-name { display: block !important; }
.sc-fbNXWD + .dsTOvD,
.blockbuilder-content-tool.disabled,
.blockbuilder-classic-tools,
.tox-toolbar__group:nth-child(4),
.dsTOvD:nth-child(3),
.dsTOvD:nth-child(4),.dsTOvD:nth-child(5),
.blockbuilder-row-tools div:nth-child(3),.blockbuilder-row-tools div:nth-child(4),.blockbuilder-row-tools div:nth-child(5),
.blockbuilder-row-tools div:nth-child(6),.blockbuilder-row-tools div:nth-child(7),.blockbuilder-row-tools div:nth-child(8),
.fa-plus,.blockbuilder-duplicate,
.blockbuilder-content-tools div:nth-child(3),
.icon-duplicate,
.blockbuilder-layer-drag-contents
{display: none !important}
#u_row_14111111111111111111111 .blockbuilder-placeholder:nth-child(1){ display: block !important; }

.blockbuilder-content-tools{ background:white;display:grid !important;}

 .blockbuilder-placeholder{display: none; }

 .u_content_button{padding: 25px 0px !important;}
 #u_content_image_31,#u_content_image_31 img{min-height: 50px;max-height: 100px;}
 .xRWac .nav-tabs .nav-item a,
 .xRWac .nav-tabs .nav-item .nav-link.active {
   color: #ffffff !important;
   background-color: #00c19d !important;
   border-color: #00c19d !important;
 }

 .layout-mobile #u_content_text_11 p {
text-align:center !important;
 }
 .hESrRY{right:375px !important}
 .enable-row-layer-outer-space{padding-top:0px !important}
 .blockbuilder-options-header .icon{border: none !important;}
 .react-toggle--checked .react-toggle-track,.blockbuilder-widget-label .btn-primary,.blockbuilder-widget-label
 .rc-slider-track{
   background-color:#00c19d !important;border: 1px solid #00c19d !important}
   .tool-panel-container .cancel-button {overflow: revert!important;text-overflow: revert!important;padding: 0px 0px!important;}
   .button-overlay mat-icon{color:#00c19d !important}
   .ReactModalPortal .btn-danger{background-color: #6c757d !important;border-color: #6c757d !important;}
   /*# sourceMappingURL=/custom.css.map */
`,
  announcementCss: `
  .u_content_heading div{padding:0px !important;margin: -7px 0px 3px 4px;}
.blockbuilder-preview{background-image:none}
.sc-fbNXWD + .dsTOvD,
.blockbuilder-content-tool.disabled,
.blockbuilder-classic-tools,
.tox-toolbar__group:nth-child(4),
.dsTOvD:nth-child(3),
.dsTOvD:nth-child(4),.dsTOvD:nth-child(5),
.blockbuilder-row-tools div:nth-child(3),.blockbuilder-row-tools div:nth-child(4),.blockbuilder-row-tools div:nth-child(5),
.blockbuilder-row-tools div:nth-child(6),.blockbuilder-row-tools div:nth-child(7),.blockbuilder-row-tools div:nth-child(8),
.fa-plus,.blockbuilder-duplicate,
.blockbuilder-content-tools div:nth-child(3),
.icon-duplicate,
.blockbuilder-layer-drag-contents
{display: none !important}
#u_row_14111111111111111111111 .blockbuilder-placeholder:nth-child(1){ display: block !important; }

.blockbuilder-content-tools{ background:white;display:grid !important;}

  .blockbuilder-placeholder{display: none; }

  .u_content_button{padding: 25px 0px !important;}
  .u_content_button a,.u_content_button span{border-radius: 80px !important;padding: 7px 10px !important;}
  #u_content_image_31,#u_content_image_31 img{min-height: 50px;max-height: 100px;}
  .xRWac .nav-tabs .nav-item a,
  .xRWac .nav-tabs .nav-item .nav-link.active {
    color: #ffffff !important;
    background-color: #00c19d !important;
    border-color: #00c19d !important;
  }

  .layout-mobile #u_content_text_11 p {
text-align:center !important;
  }
  .hESrRY{right:375px !important}
  .enable-row-layer-outer-space{padding-top:0px !important}
  .blockbuilder-options-header .icon{border: none !important;}
  .react-toggle--checked .react-toggle-track,.blockbuilder-widget-label .btn-primary,.blockbuilder-widget-label
  .rc-slider-track{
    background-color:#00c19d !important;border: 1px solid #00c19d !important}
    .tool-panel-container .cancel-button {overflow: revert!important;text-overflow: revert!important;padding: 0px 0px!important;}
    .button-overlay mat-icon{color:#00c19d !important}
    .ReactModalPortal .btn-danger{background-color: #6c757d !important;border-color: #6c757d !important;}
    /*# sourceMappingURL=/custom.css.map */
`,
  marketingProductCss: `
.blockbuilder-preview{background-image:none}
.hESrRY{overflow-x:hidden !important}
.xRWac .blockbuilder-content-tools, .xRWac .blockbuilder-classic-tools,
.blockbuilder-placeholder-empty,
.tox-toolbar__group:nth-child(4),.xRWac .nav-tabs,
.eOHSsY,.blockbuilder-text-widget,
.dsTOvD:nth-child(3),.bAaGtI,
.dsTOvD:nth-child(4),.dsTOvD:nth-child(5)
{display: none !important}
.hPcOVX{position: sticky;width: 130px;}
#u_content_image_31,#u_content_image_31 img{min-height: 50px;max-height: 100px;}
/*# sourceMappingURL=/custom.css.map */
`,
  marketingAnnouncementCss: `
.blockbuilder-preview{background-image:none}
.hESrRY{overflow-x:hidden !important}
.xRWac .blockbuilder-content-tools, .xRWac .blockbuilder-classic-tools,
.blockbuilder-placeholder-empty,
.tox-toolbar__group:nth-child(4),.xRWac .nav-tabs,
.eOHSsY,.blockbuilder-text-widget,
.dsTOvD:nth-child(3),.bAaGtI,
.dsTOvD:nth-child(4),.dsTOvD:nth-child(5)
{display: none !important}
.hPcOVX{position: sticky;width: 130px;}
#u_content_image_31,#u_content_image_31 img{min-height: 50px;max-height: 100px;}
.sc-jifIRw{display:none}
.sc-cKZHah{width:100% !important}
/*# sourceMappingURL=/custom.css.map */
`,
  fonts: [
    {
      label: 'Andale Mono',
      value: 'andale mono,times',
    },
    {
      label: 'Arial',
      value: 'arial,helvetica,sans-serif',
    },
    {
      label: 'Arial Black',
      value: 'arial black,avant garde,arial',
    },
    {
      label: 'Book Antiqua',
      value: 'book antiqua,palatino',
    },
    {
      label: 'Comic Sans MS',
      value: 'comic sans ms,sans-serif',
    },
    {
      label: 'Courier New',
      value: 'courier new,courier',
    },
    {
      label: 'Georgia',
      value: 'georgia,palatino',
    },
    {
      label: 'Helvetica',
      value: 'helvetica,sans-serif',
    },
    {
      label: 'Impact',
      value: 'impact,chicago',
    },
    {
      label: 'Symbol',
      value: 'symbol',
    },
    {
      label: 'Tahoma',
      value: 'tahoma,arial,helvetica,sans-serif',
    },
    {
      label: 'Terminal',
      value: 'terminal,monaco',
    },
    {
      label: 'Times New Roman',
      value: 'times new roman,times',
    },
    {
      label: 'Trebuchet MS',
      value: 'trebuchet ms,geneva',
    },
    {
      label: 'Verdana',
      value: 'verdana,geneva',
    },
  ],
};
